import { render, staticRenderFns } from "./flows.vue?vue&type=template&id=24307cb5&"
import script from "./flows.vue?vue&type=script&lang=js&"
export * from "./flows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports